import { render, staticRenderFns } from "./sourceManage.vue?vue&type=template&id=8d155810&scoped=true"
import script from "./sourceManage.vue?vue&type=script&lang=js"
export * from "./sourceManage.vue?vue&type=script&lang=js"
import style0 from "./sourceManage.vue?vue&type=style&index=0&id=8d155810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d155810",
  null
  
)

export default component.exports